import VueGtm from '@gtm-support/vue-gtm';
import { router } from '@/config/router';

export default function configureGoogleAnalytics(app) {
  window.addEventListener('CookieInformationConsentGiven', () => {
    if (import.meta.env.VITE_GOOGLE_ANALYTICS_ID
      && CookieInformation.getConsentGivenFor('cookie_cat_statistic')
      && CookieInformation.getConsentGivenFor('cookie_cat_marketing')) {
      app.use(VueGtm, {
        id: import.meta.env.VITE_GOOGLE_ANALYTICS_ID, // Your GTM ID
        /*
        * defaults to true. Plugin can be disabled by setting this to false
        * for Ex: enabled: !!GDPR_Cookie
        *  */
        enabled: true,
        debug: false, // Whether or not display console logs debugs
        vueRouter: router, // Pass the router instance to automatically sync with router
      });
    }
  });
}
